var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.484 16.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    d: "m8.742 15.716-1.2-1.078C3.3 10.741.5 8.212.5 5.061A4.48 4.48 0 0 1 5.033.5a4.88 4.88 0 0 1 3.709 1.741A4.88 4.88 0 0 1 12.451.5a4.48 4.48 0 0 1 4.533 4.561c0 3.151-2.8 5.68-7.047 9.577z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.5ab7e5325f5093559d7ea4142210cb5c.svg";
export { ForwardRef as ReactComponent };